import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { AppRoutes } from '@constants/app-routes'
import { filterRoute } from '@helpers/searchRoute'

const size = {
  width: '30',
  height: '30',
}

export const config = {
  links: [
    {
      id: 'Services',
      label: 'Services',
      path: '',
      additionalPaths: [
        AppRoutes.scaleYourTeam,
        AppRoutes.developYourProduct,
        AppRoutes.designStudio,
        AppRoutes.qualityAssurance,
        AppRoutes.businessAnalysisServices,
      ],
      description: {
        title: 'Services',
        subtitle: (
          <>
            Timely software development and
            <br /> incorporation of innovative
            <br /> technologies into your business are the
            <br /> main pillars that can ensure company
            <br /> growth and expansion.
          </>
        ),
      },
      info: 'true',
      withPadding: true,
      popUpHeight: '145',
      popUpWidth: '620',
      popUpLeft: '0',
      sections: [
        {
          sectionTitle: 'Services',
          sectionValues: [
            {
              value: 'Develop your product',
              link: AppRoutes.developYourProduct,
              additionalInfo: {
                title: 'Develop your product',
                subtitle:
                  'We build economically viable solutions\nby implementing custom tech projects\nthat significantly improve business\nperformance. We’ll launch your app\nwithin the deadlines and comply with\nall the KPIs.',
              },
            },
            {
              value: 'Scale your team',
              link: AppRoutes.scaleYourTeam,
              additionalInfo: {
                title: 'Scale your team',
                subtitle:
                  'Benefit from unique senior Modsen\nengineers’ expertise to strengthen your\nproject. Tap into a pool of developer\nwith an impeccable mix of tech and\ncommunicative skills.',
              },
            },
            {
              value: 'Design Studio',
              link: AppRoutes.designStudio,
              additionalInfo: {
                title: 'Design Studio',
                subtitle:
                  'We adhere to the strategic approach toward software design building, basing our processes on multiple data to create catchy selling interfaces and apps.',
              },
            },
            {
              value: 'Quality Assurance',
              link: AppRoutes.qualityAssurance,
              additionalInfo: {
                title: 'Quality Assurance',
                subtitle:
                  "Top-notch QA solutions that meet your customers' expectations and help you achieve your goals. Choose our QA services and experience the difference that quality and expertise can make in your success.",
              },
            },
            {
              value: 'Business Analysis',
              link: AppRoutes.businessAnalysisServices,
              additionalInfo: {
                title: 'Business Analysis',
                subtitle:
                  'Secure the long-term success of your business project by tapping into extensive expertise of certified Modsen business analysts.',
              },
            },
          ],
        },
      ],
      sectionsAdaptive: [
        {
          title: 'Powerfull and Simple',
          values: [
            {
              value: 'Develop your product',
              subValue: 'Technologies into your business',
              link: AppRoutes.developYourProduct,
              width: size.width,
              height: size.height,
              alt: 'Develop your product',
              src: '/images/header/terminal.svg',
            },
            {
              value: 'Scale your team',
              subValue: 'The team of skilled engineers',
              link: AppRoutes.scaleYourTeam,
              width: size.width,
              height: size.height,
              alt: 'Scale your team',
              src: '/images/header/user-group.svg',
            },
            {
              value: 'Design Studio',
              link: AppRoutes.designStudio,
              subValue: 'Present your brand to the world',
              width: size.width,
              height: size.height,
              alt: 'Design Studio',
              src: '/images/header/photograph.svg',
            },
            {
              value: 'Quality Assurance',
              link: AppRoutes.qualityAssurance,
              subValue: 'Meet quality standarts',
              width: size.width,
              height: size.height,
              alt: 'Design Studio',
              src: '/images/header/puzzle.svg',
            },
            {
              value: 'Business Analysis',
              link: AppRoutes.businessAnalysisServices,
              subValue: 'Process-based business automation',
              width: size.width,
              height: size.height,
              alt: 'Design Studio',
              src: '/images/header/calculator.svg',
            },
          ],
        },
      ],
    },
    {
      id: 'Possibilities',
      label: 'Possibilities',
      path: '',
      additionalPaths: [
        AppRoutes.mobileDevelopment,
        AppRoutes.frontend,
        AppRoutes.backend,
        AppRoutes.devOps,
        AppRoutes.enterprise,
        AppRoutes.fintech,
        AppRoutes.healthcare,
        AppRoutes.socialNetworking,
        AppRoutes.logistics,
        AppRoutes.travel,
        AppRoutes.iot,
        AppRoutes.adTech,
        AppRoutes.agriculture,
        AppRoutes.edTech,
      ],
      info: 'true',
      withPadding: true,
      hexagon: (
        <ImageWithPlaceholder
          width="175"
          height="184"
          alt="Orange empty hexagon"
          src="/images/empty-grey-hexagon.webp"
        />
      ),
      popUpHeight: '300',
      popUpWidth: '735',
      popUpLeft: '-105px',
      sectionsAdaptive: [
        {
          title: 'industries',
          values: [
            {
              value: 'Fintech',
              link: AppRoutes.fintech,
              width: size.width,
              height: size.height,
              alt: 'Fintech',
              src: '/images/header/cash.svg',
            },
            {
              value: 'Enterprise',
              link: AppRoutes.enterprise,
              width: size.width,
              height: size.height,
              alt: 'Enterprise',
              src: '/images/header/chart-square-bar.svg',
            },
            {
              value: 'Medtech',
              link: AppRoutes.healthcare,
              width: size.width,
              height: size.height,
              alt: 'Medtech',
              src: '/images/header/heart.svg',
            },
            {
              value: 'Social Networking',
              link: AppRoutes.socialNetworking,
              width: size.width,
              height: size.height,
              alt: 'Social Networking',
              src: '/images/header/annotation.svg',
            },
            {
              value: 'Logistics',
              link: AppRoutes.logistics,
              width: size.width,
              height: size.height,
              alt: 'Logistics',
              src: '/images/header/truck.svg',
            },
            {
              value: 'Travel',
              link: AppRoutes.travel,
              width: size.width,
              height: size.height,
              alt: 'Travel',
              src: '/images/header/ticket.svg',
            },
            {
              value: 'IoT',
              link: AppRoutes.iot,
              width: size.width,
              height: size.height,
              alt: 'IoT',
              src: '/images/header/cube-transparent.svg',
            },
            {
              value: 'AdTech',
              link: AppRoutes.adTech,
              width: size.width,
              height: size.height,
              alt: 'AdTech',
              src: '/images/header/chart-pie.svg',
            },
            {
              value: 'Agriculture',
              link: AppRoutes.agriculture,
              width: size.width,
              height: size.height,
              alt: 'Agriculture',
              src: '/images/agriculture/home.svg',
            },
            {
              value: 'EdTech',
              link: AppRoutes.edTech,
              width: size.width,
              height: size.height,
              alt: 'EdTech',
              src: '/images/header/graduation-cap.svg',
            },
          ],
        },
        {
          title: 'Technologies',
          values: [
            {
              value: 'Mobile Development',
              link: AppRoutes.mobileDevelopment,
              width: size.width,
              height: size.height,
              alt: 'Mobile Development',
              src: '/images/header/device-mobile.svg',
              additionalRoute: [
                { value: 'iOS', link: AppRoutes.ios },
                { value: 'Android', link: AppRoutes.android },
                {
                  value: 'React Native',
                  link: AppRoutes.reactNative,
                },
                {
                  value: 'Flutter',
                  link: AppRoutes.flutter,
                },
              ],
            },
            {
              value: 'Front-end',
              link: AppRoutes.frontend,
              width: size.width,
              height: size.height,
              alt: 'Front-end',
              src: '/images/header/desktop-computer.svg',
              additionalRoute: [
                { value: 'React', link: AppRoutes.react },
                { value: 'Angular', link: AppRoutes.angular },
                { value: 'Vue', link: AppRoutes.vue },
              ],
            },
            {
              value: 'Back-end',
              link: AppRoutes.backend,
              width: size.width,
              height: size.height,
              alt: 'Back-end',
              src: '/images/header/code.svg',
              additionalRoute: [
                { value: 'Node JS', link: AppRoutes.nodejs },
                { value: 'Java', link: AppRoutes.java },
                { value: '.NET', link: AppRoutes.netPage },
                { value: 'Python', link: AppRoutes.python },
                { value: 'PHP', link: AppRoutes.php },
              ],
            },
            {
              value: 'DevOps Services',
              link: AppRoutes.devOps,
              width: size.width,
              height: size.height,
              alt: 'DevOps Services',
              src: '/images/header/view-grid-add.svg',
              additionalRoute: [
                { value: 'Clouds', link: AppRoutes.cloud },
                { value: 'CI/CD', link: AppRoutes.cicd },
                { value: 'IaaS', link: AppRoutes.iaas },
                { value: 'Orchestration', link: AppRoutes.orchestration },
              ],
            },
          ],
        },
      ],
      sections: [
        {
          sectionTitle: 'Industries',
          sectionValues: [
            { value: 'FinTech', link: AppRoutes.fintech },
            { value: 'Enterprise', link: AppRoutes.enterprise },
            { value: 'Medtech', link: AppRoutes.healthcare },
            { value: 'Social Networking', link: AppRoutes.socialNetworking },
            { value: 'Logistics', link: AppRoutes.logistics },
            { value: 'Travel', link: AppRoutes.travel },
            { value: 'IoT', link: AppRoutes.iot },
            { value: 'AdTech', link: AppRoutes.adTech },
            { value: 'Agriculture', link: AppRoutes.agriculture },
            { value: 'EdTech', link: AppRoutes.edTech },
          ],
        },
        {
          sectionTitle: 'Technologies',
          sectionValues: [
            {
              value: 'Mobile Development',
              link: AppRoutes.mobileDevelopment,
              additionalRoute: [
                { value: 'iOS', link: AppRoutes.ios },
                { value: 'Android', link: AppRoutes.android },
                {
                  value: 'React Native',
                  link: AppRoutes.reactNative,
                },
                {
                  value: 'Flutter',
                  link: AppRoutes.flutter,
                },
              ],
            },
            {
              value: 'Front-end',
              link: AppRoutes.frontend,
              additionalRoute: [
                { value: 'React', link: AppRoutes.react },
                { value: 'Angular', link: AppRoutes.angular },
                {
                  value: 'Vue',
                  link: AppRoutes.vue,
                },
              ],
            },
            {
              value: 'Back-end',
              link: AppRoutes.backend,
              additionalRoute: [
                { value: 'Node JS', link: AppRoutes.nodejs },
                { value: 'Java', link: AppRoutes.java },
                { value: '.NET', link: AppRoutes.netPage },
                { value: 'Python', link: AppRoutes.python },
                { value: 'PHP', link: AppRoutes.php },
              ],
            },
            {
              value: 'DevOps Services',
              link: AppRoutes.devOps,
              additionalRoute: [
                { value: 'Clouds', link: AppRoutes.cloud },
                { value: 'CI/CD', link: AppRoutes.cicd },
                { value: 'IaaS', link: AppRoutes.iaas },
                { value: 'Orchestration', link: AppRoutes.orchestration },
              ],
            },
          ],
        },
      ],
      title: ['Technologies', 'Industries'],
      values: [
        { value: 'Mobile Development', link: AppRoutes.mobileDevelopment },
        { value: 'Front-end', link: AppRoutes.frontend },
        { value: 'Back-end', link: AppRoutes.backend },
        { value: 'DevOps Services', link: AppRoutes.devOps },
        { value: 'FinTech', link: AppRoutes.fintech },
        { value: 'Enterprise', link: AppRoutes.enterprise },
        { value: 'Medtech', link: AppRoutes.medtech },
        { value: 'Social Networking', link: AppRoutes.socialNetworking },
        { value: 'Logistics', link: AppRoutes.logistics },
        { value: 'Travel', link: AppRoutes.travel },
      ],
    },
    {
      id: 'Approach',
      label: 'Approach',
      path: '',
      withPadding: true,
      additionalPaths: [
        AppRoutes.agileProjectManagement,
        AppRoutes.sustainableSoftwareDevelopment,
      ],
      description: {
        title: 'Approach',
        subtitle: (
          <>
            The software development services we
            <br />
            provide are underpinned by a strong sense
            <br />
            of responsibility, unmatched quality,
            <br />
            and consistency that make our team
            <br />
            a perfect choice for fulfilling the whole
            <br />
            spectrum of the most challenging cases.
          </>
        ),
      },
      info: 'true',
      popUpHeight: '145',
      popUpWidth: '620',
      popUpLeft: '-252px',
      sections: [
        {
          sectionTitle: 'Approach',
          sectionValues: [
            {
              value: 'Agile Project Management',
              link: AppRoutes.agileProjectManagement,
            },
            {
              value: 'Sustainability',
              link: AppRoutes.sustainableSoftwareDevelopment,
            },
          ],
        },
      ],
      sectionsAdaptive: [
        {
          title: (
            <>
              LIMITLESS SOFTWARE
              <br />
              DEVELOPMENT POSSIBILITIES
            </>
          ),
          values: [
            {
              value: 'Agile Project Management',
              subValue: 'Universal approach to effective product buildin',
              link: AppRoutes.agileProjectManagement,
              width: size.width,
              height: size.height,
              alt: 'Agile Project Management',
              src: '/images/header/agile-project-management.svg',
            },
            {
              value: 'Sustainability',
              subValue: 'Responsible software development for a greener future',
              link: AppRoutes.sustainableSoftwareDevelopment,
              width: size.width,
              height: size.height,
              alt: 'Sustainability',
              src: '/images/header/sustainability.svg',
            },
          ],
        },
      ],
    },
    {
      id: 'Portfolio',
      label: 'Portfolio',
      path: AppRoutes.portfolio,
      additionalPaths: filterRoute(AppRoutes.portfolio, AppRoutes),
      values: [],
    },
    {
      id: 'Blog',
      label: 'Blog',
      path: AppRoutes.blog,
      additionalPaths: filterRoute(AppRoutes.blog, AppRoutes),
      values: [],
    },
    {
      id: 'OurTeam',
      label: 'Our Team',
      path: '',
      additionalPaths: [
        AppRoutes.aboutUs,
        AppRoutes.partnership,
        AppRoutes.news,
        AppRoutes.career,
        AppRoutes.certifications,
      ],
      description: {
        title: 'The team you are looking for',
        subtitle: (
          <>
            We’re a team united by common goals,
            <br /> philosophy, and great passion for what we
            <br /> do. Modsen experts are aimed at long-term
            <br /> cooperation and joint development together
            <br /> with our partners.
          </>
        ),
      },
      info: 'true',
      withPadding: true,
      popUpHeight: '170',
      popUpWidth: '620',
      popUpLeft: '-522px',
      sectionsAdaptive: [
        {
          title: 'Company',
          values: [
            {
              value: 'About us',
              subValue: 'We have gathered top-notch engineers',
              link: AppRoutes.aboutUs,
              alt: 'About us',
              src: '/images/header/emoji-happy.svg',
              ...size,
            },
            {
              value: 'News',
              subValue: 'Get to know Modsen better',
              link: AppRoutes.news,
              alt: 'News',
              src: '/images/header/document-text.svg',
              ...size,
            },
            {
              value: 'Career',
              subValue: 'Our team values the family vibe',
              link: AppRoutes.career,
              alt: 'Career',
              src: '/images/header/user-add.svg',
              ...size,
            },
            {
              value: 'Partnership',
              subValue: 'Your trusted partner',
              link: AppRoutes.partnership,
              alt: 'Partnership',
              src: '/images/header/key.svg',
              ...size,
            },
            {
              value: 'Certifications by Modsen',
              subValue: 'Your certificate is ready to meet its owner',
              link: AppRoutes.certifications,
              alt: 'Certifications by Modsen',
              src: '/images/header/identification.svg',
              ...size,
            },
          ],
        },
      ],
      sections: [
        {
          sectionTitle: 'Company',
          sectionValues: [
            { value: 'About us', link: AppRoutes.aboutUs },
            { value: 'Partnership', link: AppRoutes.partnership },
            { value: 'News', link: AppRoutes.news },
            { value: 'Career', link: AppRoutes.career },
            {
              value: 'Certifications by Modsen',
              link: AppRoutes.certifications,
            },
          ],
        },
      ],
    },
  ],
  buttonLink: {
    id: 'header_button_lets_work',
    path: AppRoutes.letsWork,
    label: 'Let’s Work',
  },
  buttonBookCall: {
    title: 'Go to Book a call',
  },
  socialLinks: [
    {
      id: 1,
      label: 'Facebook',
      path: 'https://www.facebook.com/ModsenSoftware',
      imagePath: '/images/facebook-footer.svg',
      imageWidth: '12',
      imageHeight: '30',
    },
    {
      id: 2,
      label: 'Instagram',
      path: 'https://www.instagram.com/modsencompany',
      imagePath: '/images/instagram-footer.svg',
      imageWidth: '30',
      imageHeight: '30',
    },
    {
      id: 3,
      label: 'Linkedin',
      path: 'https://www.linkedin.com/company/modsen',
      imagePath: '/images/linkedin-footer.svg',
      imageWidth: '30',
      imageHeight: '30',
    },
    {
      id: 4,
      label: 'X',
      path: 'https://twitter.com/modsencompany',
      imagePath: '/images/twitter-footer.svg',
      imageWidth: '30',
      imageHeight: '30',
    },
  ],
}

export const dayPickerConfig = {
  styles: {
    button: {
      fontFamily: 'Lexend Deca',
      fontWeight: 400,
      fontSize: '18px',
    },
  },
}
